import { BlogModel } from '../models/blog.model';
import { BlogUiModel } from '../ui-models/blog.ui-model';

function mapToUI(blogData: BlogModel): BlogUiModel {
  return {
    id: blogData.id || '',
    header: blogData.header,
    headerAr: blogData.headerAr,
    body: blogData.body,
    bodyAr: blogData.bodyAr,
    image: blogData.image,
    imageAr: blogData.imageAr,
    published: blogData.published,
    publishedAt: blogData.publishedAt,
    createdAt: blogData.createdAt,
    createdById: blogData.createdById,
    createdByUsername: blogData.createdByUsername,
    modifiedAt: blogData.modifiedAt,
    modifiedById: blogData.modifiedById,
    modifiedByUsername: blogData.modifiedByUsername
  };
}

function mapToModel(blogData: BlogUiModel): BlogModel {
  return {
    header: blogData.header,
    headerAr: blogData.headerAr,
    body: blogData.body,
    bodyAr: blogData.bodyAr
  };
}

function mapToUIList(blogsList: BlogModel[]): BlogUiModel[] {
  return blogsList.map(mapToUI);
}

export default {
  mapToUI,
  mapToModel,
  mapToUIList
};
